<template>
  <div class="row" id="UserInfoBox">
    <div class="col-12" style="padding-left: 0;">
      <div class="userInfoHeader">
        <p v-if="clientId == undefined || clientId == ''">Unknown user</p>
        <p v-else>Customer details</p>
      </div>
      <hr class="style-two" />
      <div v-if="clientId != undefined && clientId != '' && loading">
        <b-spinner variant="primary" label="Spinning" style="margin-top: 300px;"></b-spinner>
      </div>
      <div
        class="usersInfo"
        id="style-3"
        v-if="clientId != undefined && clientId != '' && !loading"
        :style="{ height: windowHeight-128 + 'px' }"
      >
        <!-- <h2>User Info</h2> -->

        <div>
          <b-list-group-item class="showUserInfo">
            <div
              class="chat-status text-left"
              v-if="user && user.id != undefined && user.id !== '' && user.cars"
            >
              <div>
                <b-button
                  size="sm"
                  id="showUserContact"
                  :class="visible ? 'showUserContactStyle' : 'collapsed showUserContactStyle'"
                  :aria-expanded="visible ? 'true' : 'false'"
                  aria-controls="collapse-4"
                  @click="visible = !visible"
                >
                  <div class="vertAlign">
                    <b-icon
                      :class="[visible ? 'arrowStyle' : 'arrowStyleCollapsed', 'displayInline']"
                      icon="arrow-up-short"
                    ></b-icon>
                    <span class="displayInline">Contact info</span>
                  </div>
                </b-button>
                <b-collapse id="collapse-4" v-model="visible" class="mt-2">
                  <b-card class="cardInfoStyle">
                    <div class="row makeBorder">
                      <div class="col-2 personIconStyle">
                        <b-icon class="personIconSize h2 mb-2" icon="person-square"></b-icon>
                      </div>
                      <div class="col-10 pl0 pr0">
                        <div class="padTopBot m-color fntbold">{{user.id}}</div>
                        <div
                          class="displayInline padTopBot m-color"
                        >{{user.firstName}} {{user.lastName}}</div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 padd-0">
                        <PhoneMailBox :val="user.phone" :arr="user.phones_on_file" mode="phone" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 padd-0">
                        <PhoneMailBox :val="user.email" :arr="user.emails_on_file" mode="email" />
                      </div>
                    </div>

                    <div
                      class="makeBorder"
                      style="margin-top:20px;"
                      v-if="user.contacts != undefined"
                    >
                      <b-collapse id="collapse-6" class style="margin-bottom:7px;">
                        <div class="row makeBorder" v-if="user.contacts.city">
                          <div class="col-4 padTopBot leftPad12">City:</div>
                          <div class="col-8 pl0">
                            <div class="padTopBot paddingL10">{{user.contacts.city}}</div>
                          </div>
                        </div>

                        <div class="row makeBorder" v-if="user.contacts.state">
                          <div class="col-4 padTopBot leftPad12">State:</div>
                          <div class="col-8 pl0">
                            <div class="padTopBot paddingL10">{{user.contacts.state}}</div>
                          </div>
                        </div>

                        <div class="row makeBorder" v-if="user.contacts.address">
                          <div class="col-4 padTopBot leftPad12">Address:</div>
                          <div class="col-8 pl0">
                            <div class="padTopBot paddingL10">{{user.contacts.address}}</div>
                          </div>
                        </div>

                        <div class="row makeBorder" v-if="user.contacts.ZIP">
                          <div class="col-4 padTopBot leftPad12">ZIP:</div>
                          <div class="col-8 pl0">
                            <div class="padTopBot paddingL10">{{user.contacts.ZIP}}</div>
                          </div>
                        </div>
                      </b-collapse>
                      <a
                        v-b-toggle.collapse-6
                        variant="primary"
                        class="showMoreLess"
                        v-on:click="showMoreBtn = showMoreBtn == 'Show More..' ? 'Show Less..' : 'Show More..'"
                      >{{showMoreBtn}}</a>
                    </div>
                  </b-card>
                </b-collapse>
              </div>

              <div v-if="user.messaging && user.messaging.length > 0">
                <div class="margTop20">
                  <div class="displayInline width100">
                    <b-button
                      size="sm"
                      id="showUserEvents"
                      :class="visibleMessaging ? 'showUserContactStyle' : 'collapsed showUserContactStyle'"
                      :aria-expanded="visibleMessaging ? 'true' : 'false'"
                      aria-controls="messagingList"
                      @click="visibleMessaging = !visibleMessaging"
                    >
                      <div class="vertAlign">
                        <b-icon
                          :class="[visibleMessaging ? 'arrowStyle' : 'arrowStyleCollapsed', 'displayInline']"
                          icon="arrow-up-short"
                        ></b-icon>
                        <span class="displayInline">Messaging</span>
                      </div>
                    </b-button>
                  </div>
                </div>
                <b-collapse id="messagingList" v-model="visibleMessaging" class="mt-2">
                  <div class="row" style="margin-top:10px;"></div>
                  <div
                    class="row"
                    v-for="(ms, mind) in user.messaging.slice(0, 3)"
                    :key="'msging_usri_' + mind"
                    @click="CheckPopUp(ms.sentId)"
                    v-b-popover.click="popoverConfig(ms)"
                    style="cursor: pointer;"
                  >
                    <!-- @click="CheckPopUp(ms.msId)" -->
                    <div class="col-12 padd-0">
                      <div class="row">
                        <div class="col-5 m-color cntr vcntr">{{ms.ms.title}} ({{ms.ms.category}})</div>
                        <div class="col-6 padd-0 vcntr cntr">
                          Sent On:
                          <span
                            class="m-color"
                          >{{new Date(ms.sent_time).toLocaleString('en-US', { timeZone: 'America/Edmonton' }).split(',')[0]}}</span>
                        </div>
                      </div>
                      <div class="row mtb-6" v-if="user.messaging.length > 1">
                        <div class="col-12">
                          <hr class="style-two" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="user.messaging.length > 3">
                    <div class="col-12 padd-0">
                      <a
                        v-b-toggle.messagingMore
                        style="cursor: pointer;
    color: #007bff;"
                      >Show more...</a>
                      <b-collapse id="messagingMore">
                        <div
                          class="row mtb-10"
                          v-for="(ms, mind) in user.messaging.slice(3)"
                          :key="'msging_usri_' + mind"
                          @click="CheckPopUp(ms.sentId)"
                          v-b-popover.click="popoverConfig(ms)"
                          style="cursor: pointer;"
                        >
                          <div class="col-5 m-color cntr vcntr">{{ms.ms.title}} ({{ms.ms.category}})</div>

                          <div class="col-6 padd-0 vcntr cntr">
                            Sent On
                            <span
                              class="m-color"
                            >{{new Date(ms.sent_time).toLocaleString('en-US', { timeZone: 'America/Edmonton' }).split(',')[0]}}</span>
                          </div>
                        </div>
                      </b-collapse>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <div v-if="user.fullEvents && user.cars">
                <div class="margTop20">
                  <div class="displayInline width100">
                    <b-button
                      size="sm"
                      id="showUserEvents"
                      :class="visibleEvents ? 'showUserContactStyle' : 'collapsed showUserContactStyle'"
                      :aria-expanded="visibleEvents ? 'true' : 'false'"
                      aria-controls="collapse-2"
                      @click="visibleEvents = !visibleEvents"
                    >
                      <div class="vertAlign">
                        <b-icon
                          :class="[visibleEvents ? 'arrowStyle' : 'arrowStyleCollapsed', 'displayInline']"
                          icon="arrow-up-short"
                        ></b-icon>
                        <span class="displayInline">Customer's events</span>
                      </div>
                    </b-button>
                  </div>
                </div>
                <b-collapse id="collapse-2" v-model="visibleEvents" class="mt-2">
                  <div class="row">
                    <div
                      class="col-12 makeBorder padTopBot cursorPointer"
                      v-for="ev in allEvents"
                      :key="ev.eventId"
                    >
                      <div
                        class="row evfontsize"
                        v-on:click="selectedVehicle = user.cars.find(el => el.carId == ev.car.carId); selectedEvent = ev"
                      >
                        <div class="col-3 noPadding lineHeight33 alignCenter">
                          <div
                            class="wordBreak"
                          >{{ev.type == 'appointment' && ls1530 ? 'appt' : ev.type}}</div>
                        </div>
                        <div class="col-3 noPadding lineHeight33 alignCenter">
                          <div class="wordBreak appBoldStyle">{{ev.status}}</div>
                        </div>
                        <div
                          class="col-6 noPadding lineHeight33 alignCenter"
                        >{{vh(ev.car.carId).year}} {{vh(ev.car.carId).make}} {{vh(ev.car.carId).model}}</div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <div v-if="user.cars">
                <div class="margTop20">
                  <div class="displayInline width100">
                    <b-button
                      size="sm"
                      id="showUserVehicles"
                      :class="visibleCars ? 'showUserContactStyle' : 'collapsed showUserContactStyle'"
                      :aria-expanded="visibleCars ? 'true' : 'false'"
                      aria-controls="collapse-1"
                      @click="visibleCars = !visibleCars"
                    >
                      <div class="vertAlign">
                        <b-icon
                          :class="[visibleCars ? 'arrowStyle' : 'arrowStyleCollapsed', 'displayInline']"
                          icon="arrow-up-short"
                        ></b-icon>
                        <span class="displayInline">Customer's Vehicles</span>
                      </div>
                    </b-button>
                  </div>
                </div>
                <b-collapse id="collapse-1" v-model="visibleCars" class="mt-2">
                  <div class="row" style="padding-bottom: 5px">
                    <div class="col-3 padTopBot centerAlign">
                      <img
                        class="carsIconStyle"
                        src="https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/roomadmin_pictures%2Fcar_icon.png?alt=media&token=eae59a52-c909-4e85-979c-e5bdfbddeeed"
                      />
                    </div>
                    <div class="col-9">
                      <b-form-select
                        v-model="selectedVehicle"
                        :options="carsList"
                        @change="selectedEvent = allEvents.filter(el => el.car.carId == selectedVehicle.carId).length > 0 ? allEvents.filter(el => el.car.carId == selectedVehicle.carId)[0] : {}"
                        size="sm"
                        class="mt-3"
                      ></b-form-select>
                    </div>
                  </div>

                  <div
                    class="row"
                    v-if="allEvents.filter(el => el.car.carId == selectedVehicle.carId).length > 0"
                  >
                    <div class="col-12 pl0 pr0 eventStyle">
                      <div class="row makeBorder" style="margin-bottom:20px;">
                        <div
                          class="col-3 padTopBot lineHeight30 m-color fntbold"
                        >{{ls1530 ? 'Event' : 'Car Event'}}:</div>
                        <div class="col-9" style="padding-top: 5px; ">
                          <b-form-select
                            v-model="selectedEvent"
                            :options="eventsListToShow"
                            size="sm"
                            class="mt-9"
                          ></b-form-select>
                        </div>
                      </div>

                      <div class="row" v-if="selectedEvent.type == 'parts'">
                        <div class="col-12 pl0 pr0">
                          <div class="row makeBorder">
                            <div class="col-12 padTopBot"></div>
                          </div>

                          <div class="detailsListPictPosition">
                            <!-- <img
                              class="detailsListPict"
                              src="https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/roomadmin_pictures%2Fimg_486316.png?alt=media&token=0bd94f7b-6d07-4c88-8f5f-146dd5eae9a9"
                            />-->
                          </div>

                          <div
                            class="row"
                            v-for="(partel, index) in selectedEvent.parts"
                            :key="partel.partName"
                          >
                            <div
                              class="col-3 padTopBot pl5 pr0"
                            >{{index == 0 ? 'Parts List: ' : ''}}</div>
                            <div class="col-4 padTopBot pl15">{{partel.partName}}</div>

                            <div class="col-5 padTopBot">{{partel.status}}</div>
                          </div>
                        </div>
                      </div>

                      <div class="row" v-if="selectedEvent.type == 'appointment'">
                        <div class="col-12 pl0 pr0">
                          <div class="row">
                            <div class="col-3 padTopBot m-color fntbold pl5 pr0">Details:</div>
                            <div class="col-4 padTopBot m-color pl15">Status:</div>

                            <div
                              class="col-5 padTopBot"
                            >{{selectedEvent.status == 'awaiting' ? 'Prescheduled/Waiting' : selectedEvent.status}}</div>
                          </div>

                          <div class="row">
                            <div class="col-3 pl5 pr0"></div>
                            <div class="col-4 padTopBot m-color pl15">Date:</div>

                            <div class="col-5 padTopBot">{{selectedEvent.appointment_details.date}}</div>
                          </div>

                          <div class="row">
                            <div class="col-3"></div>
                            <div class="col-4 padTopBot m-color pl15">Time:</div>
                            <div
                              class="col-5 padTopBot"
                            >{{selectedEvent.appointment_details.time || 'Not Specified'}}</div>
                          </div>

                          <div class="row">
                            <div class="col-3"></div>
                            <div class="col-4 padTopBot m-color pl15">Reason:</div>
                            <div
                              class="col-5 padTopBot"
                            >{{selectedEvent.appointment_details.reason_desc}}</div>
                          </div>

                          <!-- <div class="row">
                            <div class="col-3"></div>
                            <div class="col-4 padTopBot pl15">timestamp:</div>
                            <div
                              class="col-5 padTopBot"
                              v-if="JSON.stringify(new Date(user.cars[selected].events[selectedEvent].appointment_details.timestamp)) != 'null'"
                            >
                                 {{JSON.stringify(new Date(user.cars[selected].events[selectedEvent].appointment_details.timestamp*1000)).split("GMT")[0].split("T")[0].slice(1)}} {{JSON.stringify(new Date(user.cars[selected].events[selectedEvent].appointment_details.timestamp*1000)).split("GMT")[0].split("T")[1].slice(0, -6)}}
                            </div>
                            <div class="col-5 padTopBot" v-else>None</div>
                          </div>-->

                          <div class="row makeBorder">
                            <div class="col-3"></div>
                            <div class="col-4 padTopBot m-color pl15">User Request:</div>
                            <div
                              class="col-5 padTopBot"
                            >{{selectedEvent.appointment_details.user_request}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row" style="margin-top:10px;">
                    <div class="col-5 padTopBot">Vehicle Vin-No.</div>
                    <div class="col-7 padTopBot">{{selectedVehicle.carId}}</div>
                  </div>

                  <div class="row">
                    <div class="col-5 padTopBot">Make</div>
                    <div class="col-7 padTopBot">{{selectedVehicle.make}}</div>
                  </div>

                  <div class="row">
                    <div class="col-5 padTopBot">Model</div>
                    <div class="col-7 padTopBot">{{selectedVehicle.model}}</div>
                  </div>

                  <div class="row">
                    <div class="col-5 padTopBot">Year</div>
                    <div class="col-7 padTopBot">{{selectedVehicle.year}}</div>
                  </div>

                  <div class="row">
                    <div class="col-5 padTopBot">Milage</div>
                    <div class="col-7 padTopBot">{{selectedVehicle.kms || 'N/A'}}</div>
                  </div>

                  <div class="row">
                    <div class="col-5 padTopBot">Last service time</div>
                    <div class="col-7 padTopBot">{{selectedVehicle.last_service_time || 'N/A'}}</div>
                  </div>

                  <div class="row">
                    <div class="col-5 padTopBot">Days since last service</div>
                    <div
                      class="col-7 padTopBot"
                    >{{Math.round((new Date() - new Date(selectedVehicle.last_service_time))/(1000*60*60*24)) || 'N/A'}}</div>
                  </div>

                  <div class="row">
                    <div class="col-5 padTopBot">Description</div>
                    <div class="col-7 padTopBot">{{selectedVehicle.description}}</div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </b-list-group-item>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-6 padd-0">
          <div class="row">
            <div class="col-6">${ms.ms[d[0]]}</div>
            <div class="col-6">${ms.ms[d[0]]}</div>
          </div>
        </div>
        <div class="col-6 padd-0">
          <div class="row">
            <div class="col-6">${ms[d[1]]}</div>
            <div class="col-6">${ms[d[1]]}</div>
          </div>
        </div>
      </div>-->

      <div class="hideUserInfo" v-else>
        <div style="text-align: center"></div>
        <div class="row" v-if="!myChat" style="margin-top:25px;">
          <div class="col-12">Searching is only available for conversations assigned to you</div>
        </div>
        <b-list-group-item class="cardInfoStyle" style="margin-top: 25px;" :disabled="!myChat">
          <div class="row">
            <div
              class="col-5"
              style="padding-right: 0; text-align:right; padding-top: 5px;"
            >Search customer by:</div>
            <div class="col-7" style="padding-left: 12px;">
              <b-form-select
                v-model="userSearchParams"
                class="mb-3"
                size="sm"
                :options="userSearchParamsPool"
                @change="userSearchValue = ''; searched = false;"
              ></b-form-select>
            </div>
          </div>
          <div>
            <!-- v-model="form.userCell" -->
            <b-form @submit="findUser" @reset="onReset">
              <b-form-group id="input-group-2" label-for="input-21">
                <b-form-input
                  size="sm"
                  id="input-21"
                  v-model="userSearchValue"
                  @change="searched = false"
                  required
                  :disabled="userSearchParams == null || !userSearchParams.whereVar || !userSearchParams.oper"
                  :placeholder="userSearchParams.plholder ? userSearchParams.plholder : 'select search type above'"
                ></b-form-input>
              </b-form-group>
              <div class="row">
                <div class="col-3"></div>
                <div class="col-3">
                  <b-button size="sm" type="submit" variant="primary">Search</b-button>
                </div>

                <div class="col-3">
                  <b-button size="sm" type="reset" variant="danger">Reset</b-button>
                </div>
                <div class="col-3"></div>
              </div>
            </b-form>
          </div>
          <hr class="style-three" />
          <div class="row">
            <div
              class="col-12"
              style="padding-top: 10px; text-align: center;"
              v-if="foundUsers.length != 1 && searched"
            >
              <strong>{{foundUsers.length == 0 ? 'No customer found' : foundUsers.length > 1 ? 'Multiple customers found' : ''}}</strong>
            </div>
          </div>

          <div
            style="padding-top: 10px; overflow-y:scroll;"
            v-if="foundUsers.length != 1 && foundUsers.length > 0"
            :style="{ height: windowHeight-380 + 'px' }"
          >
            <div
              class="row"
              v-for="usersByFound in foundUsers"
              :key="usersByFound.key"
              style="margin-top: 25px;"
            >
              <div class="col-12">
                <div class="row">
                  <div class="col-12" style="padding-left: 0px;">
                    <b-form-checkbox
                      v-model="userIdentified"
                      :value="usersByFound"
                      style="float: left;"
                    ></b-form-checkbox>
                    <b-card>{{usersByFound.firstName}} - {{usersByFound.lastName}} - {{usersByFound.id}}</b-card>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3">
                    Phones:
                    <div
                      class="row"
                      v-for="userphone in usersByFound.phones_on_file"
                      :key="userphone"
                    >
                      <div class="col-12">{{userphone}}</div>
                    </div>
                  </div>
                  <div class="col-9">
                    Emails:
                    <div
                      class="row"
                      v-for="useremail in usersByFound.emails_on_file"
                      :key="useremail"
                    >
                      <div class="col-12">{{useremail}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: 30px; text-align: center">
              <div class="col-12">
                <b-button
                  @click="IdentifyFoundUser(userIdentified)"
                  variant="outline-primary"
                  :disabled="userIdentified == null"
                >{{userIdentified != null && userIdentified.id ? 'Identify customer #'+userIdentified.id : 'Select matching customer'}}</b-button>
              </div>
            </div>
          </div>
        </b-list-group-item>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import firebase from "firebase/app";
import PhoneMailBox from "./UserInfoComponents/PhoneMailBox.vue";

export default {
  name: "UserInfo",
  components: {
    PhoneMailBox
  },
  props: {
    clientId: String,
    user: Object,
    room: Object,
    myChat: Boolean,
    windowHeight: Number,
    windowWidth: Number
  },
  data() {
    return {
      showMoreBtn: "Show More..",
      visible: true,
      visibleEvents: true,
      visibleCars: true,
      visibleMessaging: true,
      allEvents: [],

      selectedVehicle: {},
      selectedEvent: {},
      searched: false,
      userSearchParams: {},
      userSearchValue: "",

      userIdentified: null,
      foundUsers: [],
      userSearchParamsPool: [
        { value: null, text: "Please select an option", disabled: true },
        {
          text: "Phone Number",

          value: {
            whereVar: "phones_on_file",
            oper: "array-contains",
            plholder: "Enter Customer's phone number"
          }
        },
        {
          text: "Email",

          value: {
            whereVar: "emails_on_file",
            oper: "array-contains",
            plholder: "Enter Customer's email"
          }
        },
        {
          text: "Customer Number",

          value: {
            whereVar: "id",
            oper: "==",
            plholder: "Enter Customer's Number/Id"
          }
        }
      ],
      msToPopup: {},
      loading: false,
      currPopMsgShown: ""
    };
  },
  created() {},

  mounted() {
    if (
      !(this.user && Object.keys(this.user).length > 0) &&
      this.clientId != ""
    ) {
      this.LoadUser();
    }

    if (this.user && this.user.cars) {
      this.selectedVehicle = this.user.cars.length > 0 ? this.user.cars[0] : {};
    }

    if (this.user && this.user.fullEvents) {
      this.allEvents = Array.from(this.user.fullEvents);
      let vehEvents = this.allEvents.filter(
        el => el.car.carId == this.selectedVehicle.carId
      );
      this.selectedEvent = vehEvents.length > 0 ? vehEvents[0] : {};
    }
  },

  watch: {
    clientId: function() {
      if (
        !(this.user && Object.keys(this.user).length > 0) &&
        this.clientId != ""
      ) {
        this.LoadUser();
      }
    },
    windowWidth: function() {
      this.AdjustPopMsgPosition();
    }
  },
  computed: {
    ls1530() {
      return this.windowWidth < 1530;
    },
    carsList() {
      let r = [];
      for (let i in this.user.cars) {
        let el = this.user.cars[i];
        r.push({ value: el, text: `${el.make} ${el.model} (${el.year})` });
      }
      return r;
    },

    eventsListToShow() {
      let arr = this.allEvents.filter(
        el => el.car.carId == this.selectedVehicle.carId
      );
      let r = [];
      for (let i in arr) {
        r.push({ value: arr[i], text: arr[i].type });
      }
      return r;
    }
  },

  methods: {
    CheckPopUp(mId) {
      if (this.currPopMsgShown != mId) {
        if (this.currPopMsgShown == "") {
          this.$root.$emit("bv::hide::popover");
        }
      } else {
        this.currPopMsgShown = mId;
      }
      let that = this;
      setTimeout(function() {
        that.AdjustPopMsgPosition();
      }, 150);
    },
    AdjustPopMsgPosition() {
      // this.$nextTick(function() {
      var x = document.getElementsByClassName("messagingPopover");

      for (let i = 0; i < x.length; i++) {
        x[i].style.setProperty(
          "--popMsgLeft",
          `${(-100 * 540) / this.windowWidth}%`
        );
        x[i].style.setProperty("--disp", `block`);
      }
      // });
    },
    popoverConfig(ms) {
      return {
        html: true,
        customClass: "messagingPopover",

        title: () => {
          return "";
        },
        content: () => {
          let htm = ``;
          [
            [
              { key: "title", name: "Messaging:" },
              { key: "sent_time", name: "Sent On:" }
            ],
            [
              { key: "category", name: "Campaign: " },
              { key: "phone", name: "Sent To Phone:       " }
            ],
            [
              { key: "type", name: "Type:     " },

              { key: "reply_received", name: "Customer Reply:" }
            ]
          ].forEach(d => {
            htm = `${htm}<div class="row" :style="{ left: -1 * 540/(2 * windowWidth) + '%' }">`;

            for (let k in d) {
              let el = d[k];
              htm = `${htm}<div class="col-6 padd-0">
          <div class="row popMsgFont">
            <div class="col vcntr padd-0 msgPopTtl" >${el.name}</div>
            <div class="col vcntr" style="text-align:left;">${
              k == 0
                ? ms.ms[el.key]
                : el.key == "sent_time"
                ? new Date(ms[el.key]).toLocaleString("en-US", {
                    timeZone: "America/Edmonton"
                  })
                : el.key == "reply_received"
                ? `${ms[el.key] === true ? "Yes" : "No"}`
                : ms[el.key]
            }</div>
          </div>
        </div>`;
            }

            htm = `${htm}</div>`;
          });
          // htm = `${htm}<div class="row"><div class="col-12 padd-0">Message Sent:</div></div>`;
          htm = `${htm} <hr class="style-two" style="margin-top: 5px; margin-bottom: 10px;" /><div class="row"><div class="col padd-0 msgPopTtl">Message Sent:</div><div class="col">${ms.sent_msg}</div></div>`;

          return htm;
          // return "The date is:<br><em>" + new Date() + "</em>";
        }
      };
    },
    valid(val) {
      return val != undefined && val != null && val !== "";
    },
    findUser(evt) {
      evt.preventDefault();
      this.foundUsers = [];

      if (this.userSearchParams != null) {
        let that = this;
        firebase
          .firestore()
          .collection(`users`)
          .where(
            this.userSearchParams.whereVar,
            this.userSearchParams.oper,
            this.userSearchValue
          )
          .get()
          .then(function(querySnapshot) {
            if (!querySnapshot.empty) {
              querySnapshot.forEach(function(doc) {
                let u = doc.data();
                if (u.id != undefined && u.id != null && u.id != "") {
                  that.foundUsers.push(u);
                }
              });
              console.log("dadfsf", that.foundUsers[0]);
              if (that.foundUsers.length == 1) {
                that.IdentifyFoundUser(that.foundUsers[0]);
              }
            }
          })
          .catch(function() {
            return;
          });
      } else {
        alert("No search option selected");
      }
    },

    IdentifyFoundUser(user) {
      firebase
        .database()
        .ref(`chatrooms/${this.room.ssId}`)
        .update({
          userId: user.id,
          user_firstName: user.firstName,
          user_lastName: user.lastName
        });

      let rm = this.room;
      rm.userId = user.id;

      let that = this;
      firebase
        .firestore()
        .doc(`users/${user.id}/sessionData/default`)
        .get()
        .then(doc => {
          if (doc.exists) {
            let d = doc.data();
            d["chatroom"] = rm;
            firebase
              .database()
              .ref(`sessionData/${that.room.ssId}`)
              .update(d);
          }
        });

      this.userSearchValue = "";
      this.searched = false;
      this.userIdentified = null;
      this.foundUsers = [];
    },

    onReset(evt) {
      if (evt != undefined) {
        evt.preventDefault();
      }
      this.foundUsers = [];
      this.userSearchValue = "";
      this.userSearchParams = {};
      this.searched = false;
      this.userIdentified = null;
    },

    vh(id) {
      return (
        this.user.cars.find(el => el.carId == id) || { make: "", model: "" }
      );
    },

    LoadUser() {
      this.loading = true;
      let that = this;
      firebase
        .firestore()
        .doc(`users/${this.clientId}`)
        .get()
        .then(doc => {
          if (doc.exists) {
            let user = doc.data();
            that.$emit("addToUserInfo", { id: user.id, user: user });
            if (
              that.room.user_firstName == "" ||
              that.room.user_lastName == ""
            ) {
              firebase
                .database()
                .ref(`chatrooms/${that.room.ssId}`)
                .update({
                  user_firstName: user.firstName,
                  user_lastName: user.lastName
                });
            }

            firebase
              .firestore()
              .collection(`users/${user.id}/cars`)
              .get()
              .then(docs => {
                let cars = [];
                docs.forEach(function(dc) {
                  cars.push(dc.data());
                });
                that.selectedVehicle = cars[0];
                that.$emit("addToUserInfo", { id: user.id, cars: cars });
              })
              .catch(function() {
                that.$emit("addToUserInfo", { id: user.id, cars: [] });
              });

            firebase
              .firestore()
              .doc(`users/${user.id}/userContacts/contact`)
              .get()
              .then(d => {
                that.$emit("addToUserInfo", {
                  id: user.id,
                  contacts: d.data()
                });
              })
              .catch(function() {
                that.$emit("addToUserInfo", { id: user.id, contacts: {} });
              });

            let loc = this.valid(user.homelocation)
              ? user.homelocation
              : "londonderrydodge";
            firebase
              .firestore()
              .collection(`messaging/${loc}/sent`)
              .where(`userId`, `==`, user.id)
              .get()
              .then(mss => {
                let msr = [];
                mss.forEach(ms => {
                  let m = ms.data();
                  m["docId"] = m.id;
                  msr.push(m);
                });
                msr.sort((a, b) => b.sent_time - a.sent_time);
                that.$emit("addToUserInfo", {
                  id: user.id,
                  messaging: msr
                });
              })
              .catch(function() {
                that.$emit("addToUserInfo", { id: user.id, messaging: [] });
              });

            if (user.events && user.events.length > 0) {
              for (let i in user.events) {
                let e = user.events[i];

                firebase
                  .firestore()
                  .doc(`events/${e.eventId}`)
                  .get()
                  .then(edoc => {
                    if (edoc.exists) {
                      that.allEvents.push(edoc.data());
                      that.selectedEvent =
                        that.allEvents.filter(
                          el => el.car.carId == that.selectedVehicle.carId
                        ).length > 0
                          ? that.allEvents.filter(
                              el => el.car.carId == that.selectedVehicle.carId
                            )[0]
                          : {};
                      that.$emit("addToUserInfo", {
                        id: user.id,
                        fullEvents: that.allEvents
                      });
                    }
                  });
              }
            }

            // that.$emit("addToUserInfo", that.user);
            that.loading = false;
          }
        })
        .catch(err => {
          that.loading = false;
          console.log("Error getting document", err);
        });
    }
  }
};
</script>
<style>
.msgPopTtl {
  max-width: fit-content;
  color: lightsteelblue;
  font-weight: bold;
}
.popMsgFont {
  margin-bottom: 5px;
  font-size: 14px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
.mtb-6 {
  margin-top: 6px;
  margin-bottom: 6px;
}
.mtb-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}
.vcntr {
  align-self: center;
}
.cntr {
  text-align: center;
}

.messagingPopover .popover-body {
  background-color: #31394c;
  color: #fff;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
.messagingPopover {
  /* left: -14% !important; */
  --disp: none;
  display: var(--disp) !important;
  --popMsgLeft: -31%;
  left: var(--popMsgLeft) !important;
  min-width: 540px;
}

.userInfoHeader {
  background-color: #ffffff;
  height: 64px;
  padding: 10px;
  border-left: 1px solid rgb(228, 228, 228);
  text-align: center;
  /* font-weight: bold; */
  font-size: 24px;
}
hr.style-two {
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.445),
    rgba(0, 0, 0, 0)
  );
  margin-top: 0px;
  margin-bottom: 0px;
}
.usersInfo {
  /* position: fixed; */
  overflow-x: hidden;
  overflow-y: scroll;
}
.showUserInfo {
  padding: 20px 10px;
}
.showUserInfo.list-group-item {
  border: none;
  border-left: 1px solid rgba(0, 0, 0, 0.125);
}
.chat-status {
  min-height: 49px;
}
.showUserContactStyle {
  width: 100%;
  background-color: rgb(228, 228, 228);
  border-color: rgb(228, 228, 228);
  color: #32465a;
  text-align: left;
  height: 47px;
}
.showUserContactStyle:hover {
  width: 100%;
  background-color: #0b306b;
  border-color: #0b306b;
  color: #ffffff;
  text-align: left;
  height: 47px;
}

.arrowStyle {
  vertical-align: middle !important;
  transform: rotate(180deg);
  width: 25px !important;
  height: 25px !important;
  transition: transform 0.4s;
}
.arrowStyleCollapsed {
  vertical-align: middle !important;
  transform: rotate(90deg);
  width: 25px !important;
  height: 25px !important;
  transition: transform 0.4s;
}
.displayInline {
  display: inline;
}
.vertAlign {
  vertical-align: text-bottom;
}
.paddL25 {
  padding-left: 25px;
}
.cardInfoStyle {
  border: none;
}
.cardInfoStyle .card-body {
  padding: 0px;
}
.personIconStyle {
  text-align: center;
  padding: 0px 10px;
  margin-bottom: 3px;
}
.personIconSize {
  height: 47px;
  width: 47px;
}
.pl0 {
  padding-left: 0px;
  /* font-weight: bold; */
}
.pr0 {
  padding-right: 0px;
}
.padTopBot {
  padding: 5px;
}
.leftPad12 {
  padding-left: 12px;
}
.paddingL10 {
  padding-left: 10px;
}
.showMoreLess {
  cursor: pointer;
  color: #007bff !important;
  padding-left: 12px;
}
.showMoreLess:hover {
  cursor: pointer;
  padding-left: 12px;
  font-weight: bold;
  color: #007bff !important;
}
.margTop20 {
  margin-top: 20px;
}
.width100 {
  width: 100%;
}
.cursorPointer {
  cursor: pointer;
  transition: 0.3s;
}
.cursorPointer:hover {
  cursor: pointer;
  background-color: #f3f3f3;
  transition: 0.3s;
}
.wordBreak {
  word-break: break-word;
}
.lineHeight33 {
  line-height: 33px;
}
.noPadding {
  padding: 0px;
}
.appBoldStyle {
  font-weight: bold;
}
.eventStyle {
  /* background-color: #f3f3f3; */
  padding-top: 5px;
  padding-bottom: 5px;
  margin-bottom: 15px;
}
.lineHeight30 {
  line-height: 30px;
}

#style-3::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

#style-3::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

#style-3::-webkit-scrollbar-thumb {
  background-color: rgba(211, 56, 0, 0.808);
}

.style-3::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.style-3::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

.style-3::-webkit-scrollbar-thumb {
  background-color: rgba(211, 56, 0, 0.808);
}
#UserInfoBox.row {
  margin-right: 0;
  margin-left: 0;
}
.padd-0 {
  padding: 0;
}
.carsIconStyle {
  width: 50px;
  height: 50px;
  transform: scale(-1, 1);
}
.m-color {
  color: #266db3;
}
.fntbold {
  font-weight: bold;
}
.alignCenter {
  text-align: center;
}

@media (max-width: 1530px) {
  .personIconSize {
    height: 33px;
    width: 33px;
    margin-top: 10px;
  }
  .personIconStyle {
    padding-left: 0;
  }
}
@media (min-width: 993px) and (max-width: 1180px) {
  .evfontsize {
    font-size: 13px;
  }
}

@media (max-width: 992px) {
  .evfontsize {
    font-size: 12px;
  }
  /* .personIconSize {
    height: 30px;
    width: 30px;
    margin-top: 10px;
  }
  .personIconStyle {
    padding-left: 0;
  } */
}
/* (min-width: 993px) and  */
</style>